<div *ngIf="espectaculoSeleccionado !== undefined; else cargando">
  <div class="ticket-info horarios-info">
    <div class="inputControl TicketsPasos">
      <span class="titulo"
        >{{ 'SESIONES_PARA' | translate }} {{ espectaculoSeleccionado.chNombreEspectaculo }}
      </span>
      <span class="Resumen"
        >{{ 'AUDITORIO' | translate }}: {{ espectaculoSeleccionado.chNombreGrupoRecintos }}
      </span>
    </div>
    <div class="inputControl calendar">
      <a class="prev" title="Previo" (click)="backDia()">
        <img class="svg" src="assets/img/active-arrow.svg" alt="icono prev" />
      </a>
      <input
        type="text"
        [value]="getFechaSeleccionada()"
        (click)="openModal('datePickAuditorio')"
      />
      <a class="next" title="Próximo" (click)="nextDia()">
        <img class="svg" src="assets/img/active-arrow.svg" alt="icono next" />
      </a>
    </div>
    <!--       <div class="inputControl TicketsPasos">
        <a
          title="Previo"
          class="prev"
          (click)="prev()"
          *ngIf="!comprobarLimitePrev()"
        >
          <img class="svg" src="assets/img/active-arrow.svg" alt="icono prev" />
        </a>
        <span class="titulo"
          >Horario para {{ espectaculoSeleccionado.chNombreEspectaculo }}
          <span *ngIf="recintos.length > 1"
            >({{ currentRecintoIndex + 1 }} de {{ recintos.length }})</span
          >
        </span>
        <span class="resumen">{{ getTotalEntradas() }} Entradas</span>
        <a
          title="Próximo"
          class="next"
          (click)="next()"
          *ngIf="!comprobarLimiteNext()"
        >
          <img class="svg" src="assets/img/active-arrow.svg" alt="icono next" />
        </a>
      </div> -->
    <!-- <div class="inputControl calendar">
        <input
          type="text"
          [value]="getFechaSeleccionada()"
          (click)="openModal('datePick')"
        />
      </div> -->
  </div>
  <div class="horariosWrap" style="align-items: center; margin-top: 20px;">
    <ticketing-accordion-sesiones class="cellSesiones" #selection>
      <!--     <ticketing-panel-sesiones
        *ngFor="let franja of franjasHorario"
        title="{{ franja }}"
        [opened]="currentRecinto.sesiones[franja].length > 0"
      >
        <div *ngFor="let sesion of currentRecinto.sesiones[franja]">
          <ticketing-cell-sesiones
            [isSelect]="isSelected(sesion)"
            [isRojo]="sesionSobrepasaCantidadEntradasSeleccionadas(sesion)"
            [isNaranja]="getTotalEntradas() > sesion.Disponible / 2"
            [isApagado]="sesion.disabled"
            time="{{ sesion.HoraInicio }}"
            ticketsLeft="({{ sesion.Disponible }})"
            (click)="seleccionarSesion(sesion)"
          >
          </ticketing-cell-sesiones>
        </div>
      </ticketing-panel-sesiones> -->
      <div *ngFor="let sesion of espectaculoSeleccionado.sesiones">
        <ticketing-cell-sesiones
          [isSelect]="isSelected(sesion)"
          [isRojo]="sesion.Estado === 3"
          [isNaranja]="sesion.Estado === 2"
          time="{{ sesion.HoraDeSesion }}"
          ticketsLeft="({{ sesion.NumButacasDisp }})"
          (click)="seleccionarSesion(sesion)"
        >
        </ticketing-cell-sesiones>
      </div>

      <!-- <ticketing-panel title="Tarde" [opened]="true">
          <div *ngFor="let sesion of currentRecinto.sesiones.tarde">
            <ticketing-cell [isSelect]="isSelected(sesion)" [isRojo]="sesionSobrepasaCantidadEntradasSeleccionadas(sesion)" [isNaranja]="getTotalEntradas() > (sesion.Disponible/ 2)" [isApagado]="sesion.disabled" time="{{sesion.HoraInicio}}" ticketsLeft="({{sesion.Disponible}})" (click)="seleccionarSesion(sesion)"></ticketing-cell>
          </div>
        </ticketing-panel>
        <ticketing-panel title="Noche" [opened]="true">
          <div *ngFor="let sesion of currentRecinto.sesiones.noche">
            <ticketing-cell [isSelect]="isSelected(sesion)" [isRojo]="sesionSobrepasaCantidadEntradasSeleccionadas(sesion)" [isNaranja]="getTotalEntradas() > (sesion.Disponible/ 2)" [isApagado]="sesion.disabled" time="{{sesion.HoraInicio}}" ticketsLeft="({{sesion.Disponible}})" (click)="seleccionarSesion(sesion)"></ticketing-cell>
          </div>
        </ticketing-panel> -->
    </ticketing-accordion-sesiones>
  </div>

  <!-- <ul class="pagination">
    <li>
      <a href="#" title="Previo">
        <img class="svg" src="assets/img/active-arrow.svg" alt="icono prev">
      </a>
    </li>
    <li><a href="#">1</a></li>
    <li><a href="#">2</a></li>
    <li><a href="#">3</a></li>
    <li><a href="#">4</a></li>
    <li><a class="active" href="#">5</a></li>
    <li><a href="#">6</a></li>
    <li>
      <a href="#" title="Próximo">
        <img class="svg" src="assets/img/active-arrow.svg" alt="icono next">
      </a>
    </li>
  </ul> -->
</div>

<ng-template #cargando>
  <div class="DetalleBox__noResultsMessage">
    <div class="lds-ring">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</ng-template>
